/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import type {
  CalcPlanListData,
  ApplyChannelData,
  CalcPlanList,
  ApplyProductData,
  FundListDataType,
  ProductCapitalItem,
} from '@/api/apply-product/types';
import {
  RateTypeEnum,
} from '@/api/apply-product/types';
import { Toast } from '@hb/coffee';
import FinanceReplan from '@/components/finance-replan/index.vue';
import type { RepayDialogDataType } from '@/components/finance-replan/types';
import FormField from '@/components/form-field';
import { repayPlanModelType } from '@/po/ProductResult';
import { ReplanResultType } from '../../types';
import { displayPlanText } from '../../product';
import RateModule from './components/rate-module';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component
export default class RepayPlan extends Vue {
  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State fundListData!: FundListDataType[] | undefined;

  @ApplyProductStore.State currentCheckFundIndex!: number;

  @ApplyProductStore.State planListData!: CalcPlanListData;

  @ApplyProductStore.State repaymentModel!: string;

  @ApplyProductStore.State multiChannelRepayment!: string

  @ApplyProductStore.State product!: ApplyProductData;

  @ApplyProductStore.State showHowToRepay!: boolean;

  @ApplyProductStore.State repayOnSchedule!: boolean;

  @ApplyProductStore.State selectRightInCapital!: ProductCapitalItem;

  @ApplyProductStore.Getter isSimplifiedListStyle!: boolean;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @ApplyProductStore.Action calcRepayPlans!: (payload?: {
    repayType: string;
    currentAmount: string;
  }) => Promise<void>;

  @ApplyProductStore.Action getCouponList!: () => Promise<void>;

  private showFinanceReplan = false;

  private get isReplanFailed(): boolean {
    return this.planListData && (this.planListData.calcResult === ReplanResultType.REPLAN_FAILED);
  }

  /** 还款计划弹窗数据 */
  private get repayDialogData(): RepayDialogDataType {
    const { repaymentModel = [], calcMethod } = this.product?.productInfo || {};
    return {
      ...this.planListData,
      routeMarket: this.channel?.routeMarket,
      calcMethod,
      repaymentModel,
    };
  }

  /** 串型资方：只有自营有 */
  private get serialCapitalName(): string {
    if (this.selectRightInCapital?.capitalListDetail) {
      return this.selectRightInCapital.capitalListDetail
        .map((it) => it.capitalName)
        .join(
          '、',
        );
    }
    return '';
  }

  private renderSubContent() {
    const { rateType = '' } = this.channel || {};
    const rateDateType = this.planListData ? this.planListData.rateType : null;
    const rateValue = this.planListData ? this.planListData.rateValue : 0;
    const bonusTotalAmount = this.planListData ? this.planListData.bonusTotalAmount : 0;

    if (this.showHowToRepay) {
      if (this.repayOnSchedule) {
        return (
          <div class={style.dueDate}>
            <span class={style.bonesIcon}>红包返现{bonusTotalAmount}元</span>
          </div>
        );
      }
      return null;
    }

    if (rateDateType && rateValue && rateType !== RateTypeEnum.CAPITAL_TYPE_36) {
      return (<RateModule/>);
    }
    return null;
  }

  private replanHtml() {
    const loanCalcList = this.planListData
      ? this.planListData.loanCalcList
      : [];
    const firstPlan = (loanCalcList && loanCalcList.length > 0
      ? loanCalcList[0]
      : null) as CalcPlanList;

    const { indexNotes } = this.planListData || {};

    if (this.isSimplifiedListStyle) {
      // 提现页面优化实验不展示副标题信息
      return (
        firstPlan ? [
          <div class={style.replanContent}>
            <div class={style.replanModel}>
              首期{firstPlan.dueDate}&nbsp;应还{firstPlan.shouldPayAmount}元
            </div>
          </div>,
        ] : [
          <div class={[style.loadingTipText, style.noMargin]}>{displayPlanText}</div>,
        ]
      );
    }
    return (
      firstPlan ? [
        <div class={style.replanContent}>
          <div class={style.replanModel}>
            首期{firstPlan.dueDate}&nbsp;应还{firstPlan.shouldPayAmount}元
          </div>
          {this.renderSubContent()}
          {indexNotes && <span class={style.fundTips}>{indexNotes}</span>}
          {(!indexNotes && this.fundListData && this.fundListData.length > 1)
          && <span class={style.fundTips}>仅供参考，实际还款计划根据匹配的资金方决定</span>}
        </div>,
      ]
        : [<div class={style.loadingTipText}>{displayPlanText}</div>]
    );
  }

  // 还款试算失败
  private renderPlanFailed() {
    const { userCalcMsg } = this.planListData || {};
    return [
      <span class={style.planFailed}>{userCalcMsg || '计算失败，请稍后再试'}</span>,
    ];
  }

  private formContent() {
    if (this.isReplanFailed) {
      return this.renderPlanFailed();
    }
    return this.replanHtml();
  }

  private render() {
    return (
      <section>
        <FormField
          name={this.isSimplifiedListStyle ? '怎么还' : '还款计划'}
          nameLoading={this.isSimplifiedListStyle === null}
          needDivider
          // 非按期还款场景 再写死 min-height 以解决抖动问题，
          // 按期还款场景，不能加，会出现割裂问题 https://blog.csdn.net/qq_44210926/article/details/125641915
          class={[!this.showHowToRepay && style.repayPlanField]}
          showArrow={!this.isReplanFailed}
          onClick={this.showPlanList.bind(this)}
          >
            {this.formContent()}
        </FormField>

        {/* 还款计划弹窗 */}
        <FinanceReplan
          show={this.showFinanceReplan}
          data={this.repayDialogData}
          fundListData={this.fundListData}
          currentCheckFundIndex={this.currentCheckFundIndex}
          capitalName={this.serialCapitalName}
          repayOnSchedule={this.repayOnSchedule}
          isSimplifiedListStyle={this.isSimplifiedListStyle}
          {...{
            on: {
              close: this.hidePlanList.bind(this),
              changeFund: this.handleChangeFund.bind(this),
              handler: this.onChangeReplan.bind(this),
            },
          }}
        />
      </section>
    );
  }

  // 切换还款方式
  private onChangeReplan(item: string) {
    this.$updateState({
      multiChannelRepayment: item,
    });

    this.$ubtPageButton('finance_applyReplan');
    /** 还款方式切换后，优惠券数据重新获取 */
    this.getCouponList();
    this.calcRepayPlans({ repayType: repayPlanModelType[item], currentAmount: this.amount });
  }

  private handleChangeFund(index: number) {
    if (
      !this.fundListData || index < 0 || index >= this.fundListData.length
    ) return;
    this.$ubtPageButton('finance_FinanceLoanApply_viewRepaymentPlan_exchangePlan');
    this.$updateState({
      planListData: this.fundListData[index],
      currentCheckFundIndex: index,
    });
  }

  // eslint-disable-next-line consistent-return
  private showPlanList() {
    this.$ubtPageButton(
      '臻有钱_提现申请_查看还款计划',
      '产品',
      this.channel && this.channel.productId,
    );
    if (!this.amount) {
      Toast('金额不能为空');
      return false;
    }
    this.showFinanceReplan = true;
  }

  private hidePlanList() {
    this.showFinanceReplan = false;
    this.$ubtPageButton(
      '臻有钱_提现申请_隐藏还款计划',
      '产品',
      this.channel && this.channel.productId,
    );
  }
}
